import React from 'react';
import { SectionHeading } from './SectionHeading';
import { BookCover } from './BookCover';
import { RichText } from './RichText';
import { bonuses } from '../../data/landing';
export function Bonuses() {
  return <section id="bonos" aria-labelledby="bonuses-title" className="scroll-mt-16 bg-cream py-16 md:py-24" data-id="element-35" data-mp="3r8v7kjp8j2qt">
      <div className="mx-auto max-w-6xl px-5" data-id="element-36" data-mp="3va8dsuw8p7y9">
        <SectionHeading id="bonuses-title" title="5 Bonos exclusivos" subtitle={<>
              Valorados en más de{' '}
              <span className="font-semibold text-accent line-through decoration-2" data-id="element-38" data-mp="rrx8kd3eensd">$70.000</span> — los recibís{' '}
              <strong className="text-ink" data-id="element-39" data-mp="dv1olpllzbxj">incluidos</strong>
            </>} data-id="element-37" data-mp="mtlyc196yb9m" />

        <ol className="mx-auto mt-12 max-w-3xl space-y-4" data-id="element-40" data-mp="iu4pqyygwy08">
          {bonuses.map(b => <li key={b.number} className="flex items-center gap-4 rounded-3xl bg-paper p-4 sm:gap-6 sm:p-5" data-id="element-41" data-mp="2yl93zbg0by3y">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-bold text-white" data-id="element-42" data-mp="33fwj4jp4fg5v">
                {b.number}
              </span>
              <BookCover eyebrow={`Bono ${b.number}`} title={b.title} color={b.color} deep={b.deep} icon={b.icon} size="sm" className="w-16 shrink-0 sm:w-20" data-id="element-43" data-mp="t05lxys3aart" />
              <div className="min-w-0 flex-1" data-id="element-44" data-mp="1gup45m6p1c9k">
                <h3 className="font-serif text-xl leading-tight text-ink" data-id="element-45" data-mp="1bxgkfh5wd067">
                  <RichText text={b.title} data-id="element-46" data-mp="1bv43967yqtu7" />
                </h3>
                <p className="mt-1 hidden text-[15px] text-muted sm:block" data-id="element-47" data-mp="1qkrxjnhq8s8f">
                  <RichText text={b.description} data-id="element-48" data-mp="1lmqc4vwtwgts" />
                </p>
                <p className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm" data-id="element-49" data-mp="1zmrfci0kg0cf">
                  <span className="text-accent line-through" data-id="element-50" data-mp="1zkexe4ut5pzd">
                    <RichText text={b.value} data-id="element-51" data-mp="1vmhbpc08xm0q" />
                  </span>
                  <span className="font-extrabold uppercase tracking-wide text-primary" data-id="element-52" data-mp="22p5m66vdrzlc">Incluido</span>
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}